export default "__VITE_PUBLIC_ASSET__4fa1809e__"